import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Progress } from './ui/progress';

interface GuardianMetricsCardProps {
  title: string;
  value: number;
  maxValue: number;
  level: string;
  trend: 'up' | 'down' | 'stable';
  icon: string;
}

export function GuardianMetricsCard({ 
  title, 
  value, 
  maxValue, 
  level, 
  trend, 
  icon 
}: GuardianMetricsCardProps) {
  const percentage = (value / maxValue) * 100;
  
  const getTrendColor = () => {
    switch (trend) {
      case 'up': return 'text-emerald-400';
      case 'down': return 'text-red-400';
      default: return 'text-blue-400';
    }
  };

  const getTrendIcon = () => {
    switch (trend) {
      case 'up': return '↗';
      case 'down': return '↘';
      default: return '→';
    }
  };

  return (
    <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-purple-500/30 hover:border-purple-400/50 transition-all duration-300">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium text-purple-200">{title}</CardTitle>
          <img src={icon} alt={title} className="w-6 h-6 opacity-80" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-2xl font-bold text-white">{value}</span>
            <Badge variant="outline" className="border-purple-400/50 text-purple-300">
              {level}
            </Badge>
          </div>
          <Progress value={percentage} className="h-2 bg-purple-900/30" />
          <div className="flex items-center justify-between text-sm">
            <span className="text-purple-300">{value}/{maxValue}</span>
            <span className={`flex items-center ${getTrendColor()}`}>
              {getTrendIcon()} {Math.abs(Math.random() * 10).toFixed(1)}%
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}